define('casino/providers/Microgaming',['jquery'], function($) {
    'use strict';

    function Microgaming(casino, gameFunctions) {
        if (!(this instanceof Microgaming)) {
            throw new TypeError('Microgaming constructor cannot be called as a function.');
        }

        this.casino = casino;
        this.gameFunctions = gameFunctions;
    }

    function freeMode(microgaming, game, options) {
        microgaming.gameFunctions.showHelpButton();
        var provider = microgaming.casino.getProvider(game);
		var src;

		if(game.html5Format === 1){
			src = provider.html5Url + game.publishCode + '/' + game.language + '?';
			src += $.param({
				casinoID: provider.demoServerId,
				loginType: 'VanguardSessionToken',
				authtoken: '',
				isRGI:'true',
				isPracticePlay:'true',
				bankingURL:'',
                lobbyURL: window.location.protocol + '//' + window.location.host  +'/close-iframe.jsp'
			});
		}
		else {
			src = provider.url + '?';
			src += $.param({
				applicationid: provider.applicationid,
				sext1: 'demo',
				sext2: 'demo',
				serverid: provider.demoServerId,
				variant: provider.demoVariant,
				gameid: game.publishCode,
				ul: game.language
			});
		}
        microgaming.gameFunctions.switchToFreeMode(game, {
            gameHolder: options.gameHolder,
            type: 'iframe',
            src: src
        });
    }

    function realMode(microgaming, game, options, data) {
        microgaming.gameFunctions.showHelpButton();
        var provider = microgaming.casino.getProvider(game);
        var src;

		if(game.html5Format === 1){
			src = provider.html5Url + game.publishCode + '/' + game.language + '?';
			src += $.param({
				casinoID: provider.serverId,
				loginType: 'VanguardSessionToken',
				authtoken: data.token,
				isRGI:'true',
				bankingURL: provider.bankingURL,
                lobbyURL: window.location.protocol + '//' + window.location.host  +'/close-iframe.jsp'
			});
		}
		else{
			src = provider.url + '?';
			src += $.param({
				applicationid: provider.applicationid,
				authtoken: data.token,
				serverid: provider.serverId,
				variant: provider.variant,
				gameid: game.publishCode,
				ul: game.language
			});
		}

        microgaming.gameFunctions.switchToRealMode(game, {
            gameHolder: options.gameHolder,
            type: 'iframe',
            src: src
        });
        microgaming.gameFunctions.verifyCurrency(data.currency);
    }

    Microgaming.prototype = {
        constructor: Microgaming,
        freeMode: function(game, options) { freeMode(this, game, options); },
        realMode: function(game, options, data) { realMode(this, game, options, data); }
    };

    return Microgaming;
});

